var _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCyStickyNote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 341 304",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 339.5,
    height: 302.332,
    rx: 59.75,
    fill: "#D9D6FD",
    stroke: "#D9D6FD",
    strokeWidth: 0.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 28.4486,
    y1: 5.99829,
    x2: 28.4486,
    y2: 293.001,
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 51.1,
    y1: 2,
    x2: 51.1,
    y2: 303,
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 75.1,
    y1: 1,
    x2: 75.1,
    y2: 303,
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 99.1,
    y1: 1,
    x2: 99.1,
    y2: 303,
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 123.1,
    y1: 1,
    x2: 123.1,
    y2: 303,
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 147.1,
    y1: 1,
    x2: 147.1,
    y2: 303,
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 171.1,
    y1: 1,
    x2: 171.1,
    y2: 303,
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 195.1,
    y1: 1,
    x2: 195.1,
    y2: 303,
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 219.1,
    y1: 1,
    x2: 219.1,
    y2: 303,
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 243.1,
    y1: 1,
    x2: 243.1,
    y2: 303,
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 267.1,
    y1: 1,
    x2: 267.1,
    y2: 303,
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 291.1,
    y1: 2,
    x2: 291.1,
    y2: 303,
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    y1: -0.1,
    x2: 340,
    y2: -0.1,
    transform: "matrix(1 0 -0.00094719 1 0.917969 65.7667)",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 0.917969,
    y1: 98.6667,
    x2: 340.918,
    y2: 98.6667,
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    y1: -0.1,
    x2: 340,
    y2: -0.1,
    transform: "matrix(1 0 -0.00047677 1 0.917969 131.767)",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    y1: -0.1,
    x2: 340,
    y2: -0.1,
    transform: "matrix(1 0 -0.000953538 0.999999 0.917969 164.767)",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    y1: -0.1,
    x2: 340,
    y2: -0.1,
    transform: "matrix(1 0 -0.00143672 0.999999 0.917969 197.767)",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    y1: -0.1,
    x2: 340,
    y2: -0.1,
    transform: "matrix(1 0 -0.00237118 0.999997 0.917969 230.767)",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 263.9,
    x2: 337,
    y2: 263.899,
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 315.595,
    y1: 11.9991,
    x2: 315.595,
    y2: 293.001,
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 32.9,
    x2: 334,
    y2: 32.9,
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 3.4375,
    y1: 0.290625,
    x2: 339.171,
    y2: 0.290625,
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M274.894 182.166C264.078 205.176 254.62 226.12 245.605 245.181C242.458 251.881 240.034 255.197 232.095 257.432C216.385 261.854 200.131 255.943 186.393 247.888C179.305 244.35 163.985 232 149.601 226.071C147.787 225.326 146.926 223.364 147.697 221.762C160.299 195.685 171.094 168.76 180.771 141.871C181.437 140.068 183.72 139.454 185.532 140.675C212.259 158.86 241.298 171.449 272.899 178.669C274.577 179.053 275.552 180.767 274.894 182.166Z",
    fill: "#8CC1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M274.894 182.166C273.081 186.024 271.267 189.859 269.499 193.695C238.923 204.04 203.538 202.859 175.149 221.671C170.593 224.694 166.58 228.868 162.341 232.591C158.283 230.154 154.089 227.921 149.601 226.071C147.787 225.326 146.926 223.363 147.697 221.762C159.44 197.463 169.89 171.81 179.116 146.406C180.613 144.33 181.995 142.209 183.288 140.043C184.036 139.998 184.829 140.201 185.532 140.675C212.259 158.86 241.298 171.449 272.899 178.669C274.577 179.052 275.552 180.767 274.894 182.166Z",
    fill: "#5AA0F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186.272 247.818C186.271 247.823 186.274 247.814 186.272 247.818C200.037 255.897 216.331 261.869 232.089 257.437C236.634 256.137 240.437 254.124 242.892 250.233C239.019 251.292 234.255 249.441 230.112 247.794C224.868 245.725 219.99 244.188 215.52 240.902C214.518 240.166 213.129 240.285 212.421 241.169C211.208 242.682 209.596 244.711 209.294 244.957C202.578 250.412 194.696 250.01 186.272 247.818Z",
    fill: "#5AA0F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M205.889 196.673C186.892 199.2 170.117 206.871 151.347 212.06C151.279 212.083 151.233 212.105 151.165 212.128C130.763 217.746 107.889 219.799 89.2326 208.766C85.3336 206.442 81.5931 203.464 79.3488 199.358C75.6912 192.752 75.4673 181.909 60.2386 97.5824C60.1479 97.1087 60.1933 96.6574 60.3293 96.2287C60.7373 94.7847 62.2335 93.7018 64.0017 93.7694C107.028 95.2812 148.649 89.0316 189.227 74.8178C191.879 73.8927 194.713 75.4268 194.917 77.9763C198.035 115.753 202.711 154.426 209.833 191.8C210.264 194.101 208.473 196.312 205.889 196.673Z",
    fill: "#FFF9C0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M204.394 160.101C173.019 150.219 137.496 154.054 107.981 139.321C87.3528 129.023 73.9535 112.162 60.3301 96.2286C60.7381 94.7846 62.2344 93.7017 64.0025 93.7693C107.029 95.281 148.65 89.0314 189.228 74.8176C191.88 73.8925 194.714 75.4267 194.918 77.9762C197.162 105.163 200.222 132.823 204.394 160.101Z",
    fill: "#FFF6A2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 212.067C151.351 212.073 151.35 212.064 151.351 212.07C130.903 217.74 107.934 219.84 89.2399 208.774C83.855 205.555 79.6678 201.673 77.8574 195.842C82.4631 198.522 89.2144 197.773 95.0996 197.074C102.541 196.208 109.33 195.901 116.2 193.209C117.739 192.606 119.48 193.234 120.085 194.609C121.12 196.965 122.489 200.12 122.793 200.538C129.531 209.83 139.785 212.004 151.35 212.067Z",
    fill: "#FFF6A2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.467 101.271C127.061 94.5251 127.974 79.3733 129.39 71.4901C129.541 70.6479 130.801 70.8907 130.652 71.7145C129.212 79.744 128.089 96.3745 133.859 102.206C131.742 98.9827 131.762 94.1783 133.977 91.0119C137.66 85.7494 145.95 86.5772 147.83 94.3553C148.204 88.6269 146.018 79.0148 144.876 70.6598C144.76 69.8078 146.033 69.6844 146.149 70.4903C147.421 79.8511 149.762 89.406 148.997 95.6468C148.167 102.382 144.247 105.769 140.064 106.036C137.125 106.254 133.683 104.657 131.467 101.271ZM135.029 91.7399C133.04 94.5872 133.117 99.1398 135.202 101.892C136.95 104.203 140.006 105.039 142.512 104.064C148.236 101.204 148.045 92.7936 143.431 89.8326C140.741 88.1052 136.975 88.9623 135.029 91.7399Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M145.356 74.3395C140.238 75.9218 134.681 76.0916 129.474 74.8289C127.421 74.331 126.263 72.139 126.888 70.1298C127.543 68.0246 128.351 65.9922 129.638 64.182C131.643 61.3595 134.959 59.2008 138.416 59.5338C143.478 60.0213 146.171 64.7971 147.74 69.633C148.373 71.587 147.326 73.7304 145.356 74.3395Z",
    fill: "#9E7AE6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M230.957 175.422C229.033 169.246 233.038 157.779 235.867 151.979C236.231 151.219 237.394 151.775 237.02 152.537C234.312 158.091 230.208 169.665 232.325 175.46C231.959 172.727 233.052 169.665 235.168 167.938C238.976 164.83 244.973 166.755 245.314 172.754C246.61 168.512 247.086 160.757 247.947 154.729C248.07 153.872 249.333 154.084 249.215 154.908C248.15 162.422 247.858 170.26 245.905 174.899C242.165 183.771 233.191 182.59 230.957 175.422ZM235.98 168.925C233.871 170.648 232.954 174.101 233.936 176.621C234.753 178.716 236.864 179.97 238.934 179.793C243.851 178.854 245.529 172.482 242.681 169.259C241.036 167.402 238.031 167.248 235.98 168.925Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M247.64 157.678C243.36 157.788 239.049 156.717 235.321 154.62C233.851 153.793 233.44 151.857 234.359 150.448C235.322 148.97 236.387 147.582 237.772 146.469C239.93 144.732 242.951 143.789 245.536 144.793C249.322 146.262 250.35 150.517 250.501 154.574C250.561 156.214 249.288 157.636 247.64 157.678Z",
    fill: "#FFC100"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M200.221 133.539C199.885 133.539 199.602 133.279 199.582 132.943C198.315 113.827 195.837 94.5897 192.217 75.7685C192.057 74.948 193.316 74.6854 193.475 75.5291C197.107 94.4027 199.592 113.69 200.86 132.858C200.885 133.21 200.617 133.514 200.264 133.536C200.249 133.539 200.234 133.539 200.221 133.539Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M241.932 250.121L260.753 213.097C261.126 212.349 262.282 212.911 261.895 213.675L243.074 250.699C242.695 251.445 241.545 250.885 241.932 250.121Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M122.703 73.7387L117.037 72.6118C116.204 72.4448 116.454 71.1921 117.287 71.3602L122.954 72.4871C123.302 72.5569 123.528 72.891 123.457 73.2376C123.394 73.5603 123.085 73.8057 122.703 73.7387Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M121.893 69.3809L116.51 65.4341C115.827 64.9339 116.586 63.9063 117.271 64.4069L122.655 68.3537C122.94 68.5631 123 68.962 122.79 69.2463C122.581 69.5283 122.179 69.5911 121.893 69.3809Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M123.425 65.282C122.15 63.3173 121.26 61.1557 120.784 58.862C120.714 58.5154 120.937 58.1788 121.283 58.1065C122.642 57.8588 121.533 60.0172 124.502 64.5889C124.964 65.299 123.884 65.991 123.425 65.282Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M250.976 146.324L253.243 143.501C253.785 142.842 254.77 143.646 254.245 144.299L251.978 147.121C251.453 147.78 250.446 146.989 250.976 146.324Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M253.172 150.909C252.333 150.909 252.32 149.656 253.152 149.632C253.908 149.61 250.415 149.713 260.542 149.416C261.381 149.416 261.394 150.669 260.562 150.692L253.192 150.909C253.185 150.909 253.172 150.909 253.172 150.909Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M259.072 159.126L253.405 155.745C252.681 155.314 253.323 154.217 254.061 154.648L259.733 158.029C260.446 158.458 259.822 159.553 259.072 159.126Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyStickyNote);
export default __webpack_public_path__ + "static/media/cy-sticky-note.d13c6b282a05d57bcb7cbc367939570e.svg";
export { ForwardRef as ReactComponent };